import React, { useState } from 'react';
import './SubtextWordsList.css';

interface SubtextWordsListProps {
  words: string[];
  className?: string;
  longestSubWordLength?: number;
}

const WORDS_PER_PAGE = 20; // 10 words per column, 2 columns

export default function SubtextWordsList({ words, className = '', longestSubWordLength }: SubtextWordsListProps) {
  const [currentPage, setCurrentPage] = useState(0);
  
  // Sort words alphabetically
  const sortedWords = [...words].sort();
  
  // Calculate pagination
  const totalPages = Math.ceil(sortedWords.length / WORDS_PER_PAGE);
  const startIndex = currentPage * WORDS_PER_PAGE;
  const endIndex = Math.min(startIndex + WORDS_PER_PAGE, sortedWords.length);
  const currentWords = sortedWords.slice(startIndex, endIndex);
  
  // Split current words into two columns
  const wordsPerColumn = Math.ceil(WORDS_PER_PAGE / 2);
  const leftColumn = currentWords.slice(0, wordsPerColumn);
  const rightColumn = currentWords.slice(wordsPerColumn);
  
  const capitalizeWord = (word: string): string => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };
  
  const handlePrevPage = () => {
    setCurrentPage(Math.max(0, currentPage - 1));
  };
  
  const handleNextPage = () => {
    setCurrentPage(Math.min(totalPages - 1, currentPage + 1));
  };
  
  return (
    <div className={`subtext-words-list ${className}`}>
      <>
        <div className="words-grid">
          <div className="words-column">
            {leftColumn.map((word, index) => (
              <div 
                key={`left-${index}`} 
                className={`word-item ${longestSubWordLength && word.length === longestSubWordLength ? 'longest-word' : ''}`}
              >
                {capitalizeWord(word)}
              </div>
            ))}
          </div>
          <div className="words-column">
            {rightColumn.map((word, index) => (
              <div 
                key={`right-${index}`} 
                className={`word-item ${longestSubWordLength && word.length === longestSubWordLength ? 'longest-word' : ''}`}
              >
                {capitalizeWord(word)}
              </div>
            ))}
          </div>
        </div>
        
        {totalPages > 1 && (
          <div className="pagination-controls">
            {currentPage > 0 && (
              <button 
                className="pagination-btn" 
                onClick={handlePrevPage}
              >
                ←
              </button>
            )}
            <span className="page-indicator">
              Page {currentPage + 1} of {totalPages}
            </span>
            {currentPage < totalPages - 1 && (
              <button 
                className="pagination-btn"
                onClick={handleNextPage}
              >
                →
              </button>
            )}
          </div>
        )}
      </>
    </div>
  );
} 